import { usePathname, useRouter } from 'expo-router';
import React from 'react';
import { View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import type { NavigationButtonTypes } from '@/components/navigation-button';
import { NavigationButton } from '@/components/navigation-button';

interface NavbarProps {
  type: NavigationButtonTypes;
  disabled?: boolean;
  loading?: boolean;
  onPress?: () => void;
  Icon?: React.ReactNode;
  linkPath?: string;
  style?: any;
  buttonStyle?: any;
}

export default function Navbar({
  type,
  disabled,
  loading,
  onPress,
  linkPath,
  style,
  buttonStyle,
  ...props
}: NavbarProps) {
  const { styles } = useStyles(stylesheet);
  const router = useRouter();
  const pathname = usePathname();

  return (
    <View style={[styles.container, style]}>
      <NavigationButton
        type={type}
        onPress={() => {
          if (onPress) {
            onPress();
            return;
          }

          if (linkPath) {
            router.navigate(linkPath);
            return;
          }

          if (router.canGoBack()) {
            const pathSegments = pathname.split('/').filter(Boolean);

            if (pathSegments.length > 1) {
              // Remove the last segment to get the parent path
              const parentPath = `/${pathSegments.slice(0, -1).join('/')}`;
              router.replace(parentPath);
            } else {
              router.replace('/search');
            }

            // router.back();
          }
        }}
        style={[styles.button, buttonStyle]}
      />
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    width: '100%',
    backgroundColor: theme.colors.background_2,
    paddingTop: UnistylesRuntime.insets.top,
    paddingLeft: 16,
    borderRadius: 16,
    borderBottomStartRadius: 0,
    borderBottomEndRadius: 0,
  },
  button: {
    alignSelf: 'flex-end',
    marginBottom: 16,
    marginRight: 16,
    marginTop: {
      xs: 16,
      sm: 16,
      md: 16,
      lg: 16,
    },
  },
}));
